// Series colours generated from the golden angle, so a chart with any number of
// series gets a distinct hue per series without a fixed palette to run out of.
// Shared by every multi-series chart, so the same series index always reads as
// the same colour across the app.
export function getSeriesColorValues(index) {
  return {
    hue: Math.round(index * 137.508),
    saturation: 64 + (index % 3) * 8,
    lightness: 42 + (Math.floor(index / 3) % 4) * 7,
  }
}

export function getSeriesColor(index) {
  const { hue, saturation, lightness } = getSeriesColorValues(index)

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}

// Ink that stays readable on top of the series colour, for labels sitting inside
// a filled mark
export function getSeriesTextColor(index) {
  return getSeriesColorValues(index).lightness > 58 ? "#000" : "#fff"
}
